// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1v8u_d","text":"fufchs"};